module.exports = __webpack_public_path__ + "static/media/eirich-mixer-testing-s.e97fe90b.jpg";